"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f103 = void 0;
exports.f103 = {
    "ghotuo": [
        8
    ],
    "guinea": [
        2672,
        297,
        547,
        586,
        739,
        870,
        957,
        1046,
        1941,
        2342,
        2416,
        3517,
        3798,
        3841,
        3862,
        4018,
        4119,
        4286,
        4376,
        4378,
        4653,
        4670,
        4830,
        5106,
        5109,
        5587,
        6059,
        6091,
        6264,
        6693,
        6878,
        7052,
        7666,
        8004,
        8281,
        666,
        792,
        947,
        1054,
        1055,
        1131,
        1139,
        1140,
        2353,
        2370,
        2437,
        2483,
        2484,
        2485,
        2820,
        3308,
        3739,
        3740,
        3916,
        4261,
        4393,
        4587,
        4588,
        4589,
        4620,
        4714,
        4715,
        4866,
        5075,
        5289,
        5657,
        6054,
        7199,
        7200,
        7641,
        8729,
        8730,
        9054,
        10,
        11,
        15,
        16,
        17,
        18,
        26,
        27,
        38,
        51,
        52,
        53,
        56,
        58,
        99,
        111,
        129,
        130,
        131,
        137,
        141,
        142,
        145,
        153,
        154,
        156,
        162,
        163,
        165,
        196,
        198,
        199,
        206,
        218,
        239,
        240,
        247,
        250,
        264,
        279,
        298,
        300,
        304,
        322,
        324,
        341,
        343,
        345,
        347,
        348,
        349,
        350,
        353,
        354,
        355,
        358,
        359,
        371,
        372,
        373,
        383,
        386,
        387,
        394,
        473,
        482,
        485,
        490,
        516,
        518,
        521,
        523,
        525,
        530,
        533,
        542,
        552,
        554,
        562,
        563,
        573,
        634,
        637,
        639,
        647,
        651,
        655,
        665,
        667,
        671,
        673,
        680,
        688,
        690,
        720,
        726,
        729,
        749,
        812,
        813,
        819,
        840,
        842,
        848,
        850,
        851,
        852,
        861,
        865,
        869,
        875,
        876,
        885,
        927,
        946,
        951,
        954,
        959,
        964,
        967,
        968,
        979,
        984,
        987,
        993,
        1009,
        1013,
        1015,
        1016,
        1021,
        1029,
        1032,
        1036,
        1044,
        1061,
        1068,
        1096,
        1112,
        1113,
        1157,
        1182,
        1185,
        1187,
        1189,
        1191,
        1197,
        1209,
        1224,
        1227,
        1232,
        1234,
        1250,
        1253,
        1255,
        1270,
        1275,
        1289,
        1294,
        1295,
        1302,
        1304,
        1341,
        1433,
        1488,
        1493,
        1506,
        1723,
        1724,
        1728,
        1767,
        1775,
        1794,
        1811,
        1817,
        1818,
        1831,
        1832,
        1845,
        1884,
        1898,
        1915,
        1924,
        1930,
        1931,
        1934,
        1940,
        1997,
        2003,
        2004,
        2021,
        2028,
        2074,
        2075,
        2094,
        2097,
        2100,
        2106,
        2192,
        2227,
        2237,
        2249,
        2271,
        2309,
        2331,
        2332,
        2333,
        2335,
        2337,
        2338,
        2377,
        2392,
        2411,
        2414,
        2417,
        2439,
        2472,
        2499,
        2513,
        2517,
        2518,
        2519,
        2522,
        2526,
        2527,
        2529,
        2531,
        2533,
        2543,
        2544,
        2565,
        2570,
        2578,
        2589,
        2592,
        2598,
        2615,
        2623,
        2624,
        2626,
        2636,
        2647,
        2649,
        2667,
        2668,
        2691,
        2697,
        2715,
        2719,
        2720,
        2725,
        2732,
        2755,
        2768,
        2774,
        2783,
        2784,
        2786,
        2791,
        2793,
        2829,
        2830,
        2839,
        2858,
        2889,
        2897,
        2899,
        2929,
        2930,
        2932,
        2943,
        2961,
        2964,
        2992,
        3015,
        3016,
        3018,
        3035,
        3046,
        3055,
        3076,
        3079,
        3082,
        3112,
        3114,
        3139,
        3157,
        3159,
        3161,
        3206,
        3208,
        3209,
        3222,
        3229,
        3231,
        3232,
        3246,
        3273,
        3291,
        3293,
        3309,
        3328,
        3353,
        3370,
        3382,
        3389,
        3398,
        3487,
        3489,
        3494,
        3498,
        3501,
        3502,
        3507,
        3520,
        3525,
        3536,
        3565,
        3581,
        3624,
        3638,
        3654,
        3662,
        3669,
        3678,
        3680,
        3686,
        3687,
        3690,
        3699,
        3721,
        3725,
        3726,
        3737,
        3771,
        3776,
        3779,
        3780,
        3784,
        3788,
        3799,
        3800,
        3806,
        3807,
        3810,
        3812,
        3815,
        3837,
        3842,
        3851,
        3864,
        3872,
        3879,
        3890,
        3894,
        3895,
        3898,
        3899,
        3900,
        3903,
        3906,
        3907,
        3909,
        3920,
        3957,
        3958,
        3962,
        3963,
        3965,
        3971,
        3992,
        3994,
        3996,
        4017,
        4030,
        4031,
        4047,
        4051,
        4082,
        4087,
        4098,
        4121,
        4125,
        4128,
        4134,
        4138,
        4159,
        4160,
        4166,
        4216,
        4219,
        4232,
        4236,
        4237,
        4248,
        4273,
        4275,
        4282,
        4283,
        4285,
        4310,
        4325,
        4327,
        4332,
        4365,
        4379,
        4385,
        4399,
        4429,
        4432,
        4448,
        4458,
        4501,
        4522,
        4560,
        4606,
        4609,
        4615,
        4621,
        4622,
        4627,
        4633,
        4641,
        4642,
        4646,
        4649,
        4650,
        4652,
        4681,
        4683,
        4684,
        4689,
        4700,
        4701,
        4729,
        4732,
        4751,
        4760,
        4761,
        4772,
        4777,
        4814,
        4825,
        4826,
        4829,
        4849,
        4861,
        4863,
        4878,
        4881,
        4889,
        4909,
        4915,
        4916,
        4917,
        4919,
        4923,
        4933,
        4948,
        4980,
        4995,
        4997,
        4998,
        4999,
        5002,
        5003,
        5005,
        5007,
        5013,
        5030,
        5031,
        5035,
        5092,
        5095,
        5096,
        5097,
        5103,
        5122,
        5125,
        5137,
        5146,
        5150,
        5160,
        5162,
        5165,
        5175,
        5176,
        5177,
        5180,
        5181,
        5215,
        5217,
        5227,
        5251,
        5261,
        5276,
        5281,
        5285,
        5287,
        5290,
        5291,
        5302,
        5305,
        5319,
        5332,
        5333,
        5336,
        5338,
        5339,
        5346,
        5347,
        5348,
        5398,
        5406,
        5412,
        5457,
        5469,
        5472,
        5475,
        5484,
        5489,
        5492,
        5517,
        5523,
        5568,
        5586,
        5596,
        5602,
        5604,
        5619,
        5623,
        5625,
        5632,
        5636,
        5646,
        5656,
        5680,
        5694,
        5700,
        5727,
        5732,
        5741,
        5742,
        5749,
        5754,
        5768,
        5784,
        5858,
        5880,
        5888,
        5912,
        5917,
        5923,
        5925,
        5926,
        5927,
        5931,
        5932,
        5933,
        5944,
        5945,
        5956,
        5978,
        6000,
        6003,
        6005,
        6010,
        6081,
        6098,
        6102,
        6105,
        6114,
        6120,
        6154,
        6163,
        6170,
        6182,
        6217,
        6235,
        6239,
        6268,
        6273,
        6274,
        6276,
        6278,
        6293,
        6302,
        6320,
        6322,
        6333,
        6346,
        6366,
        6372,
        6374,
        6376,
        6462,
        6465,
        6469,
        6492,
        6516,
        6549,
        6557,
        6584,
        6591,
        6597,
        6599,
        6637,
        6641,
        6642,
        6695,
        6698,
        6699,
        6707,
        6755,
        6783,
        6788,
        6796,
        6828,
        6875,
        6880,
        6883,
        6884,
        6885,
        6886,
        6905,
        6914,
        6922,
        6931,
        6949,
        6958,
        6964,
        6965,
        6967,
        6968,
        6978,
        6988,
        6992,
        7006,
        7007,
        7009,
        7014,
        7015,
        7016,
        7037,
        7040,
        7045,
        7051,
        7055,
        7056,
        7057,
        7063,
        7100,
        7106,
        7125,
        7131,
        7135,
        7138,
        7143,
        7149,
        7150,
        7152,
        7155,
        7162,
        7168,
        7170,
        7187,
        7190,
        7191,
        7192,
        7195,
        7216,
        7240,
        7243,
        7322,
        7330,
        7331,
        7333,
        7334,
        7337,
        7343,
        7346,
        7349,
        7352,
        7363,
        7417,
        7448,
        7453,
        7456,
        7462,
        7498,
        7507,
        7509,
        7552,
        7564,
        7583,
        7590,
        7604,
        7611,
        7620,
        7630,
        7642,
        7660,
        7682,
        7685,
        7687,
        7688,
        7701,
        7707,
        7750,
        7758,
        7759,
        7776,
        7777,
        7781,
        7783,
        7784,
        7785,
        7790,
        7831,
        7836,
        7861,
        7892,
        7895,
        7899,
        7900,
        7901,
        7902,
        7915,
        7928,
        7933,
        7953,
        7968,
        7972,
        7980,
        7985,
        7997,
        7999,
        8002,
        8007,
        8009,
        8010,
        8011,
        8014,
        8021,
        8027,
        8034,
        8035,
        8053,
        8054,
        8055,
        8089,
        8110,
        8149,
        8154,
        8157,
        8168,
        8172,
        8174,
        8197,
        8204,
        8207,
        8211,
        8218,
        8220,
        8225,
        8234,
        8241,
        8242,
        8254,
        8273,
        8286,
        8287,
        8288,
        8298,
        8299,
        8306,
        8312,
        8319,
        8335,
        8337,
        8348,
        8349,
        8353,
        8356,
        8368,
        8372,
        8405,
        8418,
        8457,
        8459,
        8513,
        8517,
        8578,
        8585,
        8587,
        8626,
        8633,
        8637,
        8755,
        8757,
        8758,
        8759,
        8765,
        8767,
        8771,
        8779,
        8783,
        8784,
        8786,
        8789,
        8808,
        8818,
        8820,
        8823,
        8827,
        8828,
        8829,
        8830,
        8832,
        8837,
        8839,
        8848,
        8851,
        8852,
        8863,
        8873,
        8879,
        8892,
        8893,
        8901,
        8912,
        8917,
        8930,
        8938,
        8939,
        8945,
        8962,
        9008,
        9017,
        9051,
        9053,
        9088,
        9155,
        9159,
        9175
    ],
    "gjegje": [
        12,
        13
    ],
    "gr": [
        25,
        1587,
        2057,
        2090,
        2091,
        2701,
        2765,
        2766,
        2794,
        4187,
        6241,
        6242,
        6507,
        6555,
        6628,
        6629,
        7071,
        7732
    ],
    "greece": [
        25,
        1587,
        2057,
        2090,
        2091,
        2701,
        2765,
        2766,
        2794,
        4187,
        6241,
        6242,
        6507,
        6555,
        6628,
        6629,
        7071,
        7732
    ],
    "green river": [
        26
    ],
    "green": [
        2650,
        26,
        3005,
        3006,
        3007,
        3008,
        3009
    ],
    "ge": [
        2981,
        2605,
        3750,
        30,
        31,
        645,
        821,
        3356,
        3452,
        3453,
        3454,
        4014,
        4569,
        4570,
        5825,
        5850,
        5965,
        7213,
        7214,
        7215,
        8028,
        8029,
        8535
    ],
    "georgia": [
        30,
        31,
        645,
        821,
        3356,
        3452,
        3453,
        3454,
        4014,
        4569,
        4570,
        5825,
        5850,
        5965,
        7213,
        7214,
        7215,
        8028,
        8029,
        8535
    ],
    "gyaman": [
        49
    ],
    "gh": [
        49,
        62,
        87,
        100,
        102,
        103,
        140,
        148,
        176,
        230,
        231,
        246,
        320,
        539,
        846,
        854,
        1020,
        1243,
        1504,
        1518,
        1522,
        1589,
        1726,
        1727,
        1813,
        1951,
        2060,
        2061,
        2156,
        2356,
        2368,
        2507,
        2508,
        2662,
        2663,
        2754,
        2787,
        2819,
        2856,
        2878,
        2888,
        3396,
        3448,
        3792,
        3881,
        4033,
        4136,
        4209,
        4271,
        4308,
        4331,
        4338,
        4596,
        4597,
        5278,
        5304,
        5355,
        5418,
        5525,
        5527,
        5555,
        5612,
        5719,
        5788,
        5815,
        6663,
        6803,
        6872,
        6877,
        7013,
        7140,
        7358,
        7670,
        8048,
        8269,
        8350,
        8509,
        8582,
        8583,
        8634,
        8702
    ],
    "ghana": [
        8702,
        854,
        1243,
        8269,
        49,
        62,
        87,
        100,
        102,
        103,
        140,
        148,
        176,
        230,
        231,
        246,
        320,
        539,
        846,
        1020,
        1504,
        1518,
        1522,
        1589,
        1726,
        1727,
        1813,
        1951,
        2060,
        2061,
        2156,
        2356,
        2368,
        2507,
        2508,
        2662,
        2663,
        2754,
        2787,
        2819,
        2856,
        2878,
        2888,
        3396,
        3448,
        3792,
        3881,
        4033,
        4136,
        4209,
        4271,
        4308,
        4331,
        4338,
        4596,
        4597,
        5278,
        5304,
        5355,
        5418,
        5525,
        5527,
        5555,
        5612,
        5719,
        5788,
        5815,
        6663,
        6803,
        6872,
        6877,
        7013,
        7140,
        7358,
        7670,
        8048,
        8350,
        8509,
        8582,
        8583,
        8634
    ],
    "gikyode": [
        62
    ],
    "gichode": [
        62
    ],
    "gang": [
        66,
        1281
    ],
    "gelet": [
        70
    ],
    "gt": [
        74,
        75,
        76,
        170,
        1328,
        1330,
        1338,
        1513,
        2272,
        2790,
        3280,
        3295,
        3307,
        3568,
        3697,
        3827,
        4585,
        6250,
        6254,
        6398,
        6405,
        6411,
        7757,
        7881,
        7882,
        8019,
        8485
    ],
    "guatemala": [
        74,
        75,
        76,
        170,
        1328,
        1330,
        1338,
        1513,
        2272,
        2790,
        3280,
        3295,
        3307,
        3568,
        3697,
        3827,
        4585,
        6250,
        6254,
        6398,
        6405,
        6411,
        7757,
        7881,
        7882,
        8019,
        8485
    ],
    "garme": [
        86
    ],
    "gɩdɩrɛ": [
        90
    ],
    "gadre": [
        90
    ],
    "gidere": [
        90
    ],
    "gidire": [
        90
    ],
    "galo": [
        97
    ],
    "gallong": [
        97
    ],
    "galong": [
        97
    ],
    "gadjnjamada": [
        104
    ],
    "gaolkheel": [
        128
    ],
    "gokhu": [
        128
    ],
    "gokhy": [
        128
    ],
    "gulf": [
        136,
        2111,
        2112
    ],
    "gulf arabic": [
        136
    ],
    "gulf spoken": [
        136
    ],
    "gwɨrkŋɨ": [
        141
    ],
    "gbo": [
        151
    ],
    "galigalu": [
        204
    ],
    "gy": [
        236,
        365,
        1081,
        2160,
        2866,
        5279,
        6044,
        6935,
        7397,
        8163
    ],
    "guyana": [
        236,
        365,
        1081,
        2160,
        2866,
        5279,
        6044,
        6935,
        7397,
        8163
    ],
    "ghahvalal": [
        252
    ],
    "galawa": [
        263
    ],
    "galleewo": [
        263
    ],
    "gheg": [
        269,
        270
    ],
    "geg": [
        269,
        270
    ],
    "gegnisht": [
        269,
        270
    ],
    "gegnisht-shqyp": [
        269,
        270
    ],
    "gheg albanian": [
        269,
        270
    ],
    "guegue": [
        269,
        270
    ],
    "guerrero": [
        305,
        5439,
        4572,
        4804,
        4816
    ],
    "guerrero amuzgo": [
        305
    ],
    "gae": [
        316
    ],
    "gaye": [
        316
    ],
    "gb": [
        321,
        750,
        751,
        1558,
        1708,
        1709,
        2134,
        2153,
        2210,
        2234,
        2573,
        2628,
        4072,
        5673,
        5674,
        5838,
        6006,
        6185,
        6544,
        6563,
        6731,
        7710,
        8262,
        8595,
        8877,
        9023
    ],
    "goemai": [
        325
    ],
    "gamai": [
        325,
        2518
    ],
    "groote eylandt": [
        352
    ],
    "groote": [
        352
    ],
    "gunung": [
        366,
        6824
    ],
    "gabonese sign language": [
        463,
        464
    ],
    "gabonese": [
        463,
        464
    ],
    "gebärdensprache": [
        475,
        2788,
        6811
    ],
    "gros ventre": [
        502
    ],
    "gros": [
        502
    ],
    "gros ventres": [
        502
    ],
    "gabobora": [
        516
    ],
    "gbanda": [
        535
    ],
    "gawnaru": [
        546
    ],
    "grosso": [
        567
    ],
    "gbe, ayizo": [
        574
    ],
    "gbe": [
        574,
        1465,
        2546,
        2558,
        2562,
        3908,
        5216,
        7265,
        7437,
        8195,
        8208,
        8693,
        8697,
        2060,
        2061
    ],
    "ginyanga": [
        578
    ],
    "genyanga": [
        578
    ],
    "garaygosode": [
        584
    ],
    "guarañoca": [
        584
    ],
    "guidaigosode": [
        584
    ],
    "golden phula": [
        598
    ],
    "golden": [
        598,
        6191
    ],
    "guñuun": [
        611,
        684
    ],
    "gújááhár": [
        611
    ],
    "gw": [
        611,
        841,
        864,
        916,
        1377,
        2076,
        2358,
        2371,
        3515,
        3825,
        4731,
        5094,
        6053,
        6264,
        6334
    ],
    "guinea-bissau": [
        6264,
        611,
        841,
        864,
        916,
        1377,
        2076,
        2358,
        2371,
        3515,
        3825,
        4731,
        5094,
        6053,
        6334
    ],
    "gajebo": [
        612
    ],
    "garaka": [
        627
    ],
    "gwataley": [
        632
    ],
    "ghibarama": [
        640
    ],
    "gibarama": [
        640
    ],
    "givarama": [
        640
    ],
    "ga": [
        2507,
        2508,
        640,
        1192,
        1896,
        2435,
        2610,
        3497,
        3559,
        3865,
        4174,
        4530,
        4768,
        5235,
        5564,
        5663,
        5780,
        5813,
        6144,
        6370,
        6667,
        6714,
        7008,
        7237,
        7255,
        7269,
        7280,
        7364,
        7415,
        7748,
        8143,
        8196,
        8365,
        9094
    ],
    "gabon": [
        3865,
        7008,
        640,
        1192,
        1896,
        2435,
        2610,
        3497,
        3559,
        4174,
        4530,
        4768,
        5235,
        5564,
        5663,
        5780,
        5813,
        6144,
        6370,
        6667,
        6714,
        7237,
        7255,
        7269,
        7280,
        7364,
        7415,
        7748,
        8143,
        8196,
        8365,
        9094
    ],
    "ghomálá’": [
        643
    ],
    "ghomálá'": [
        643
    ],
    "ghᴐmala’": [
        643
    ],
    "gaʼa-kejom": [
        644
    ],
    "ga’a kedjom": [
        644
    ],
    "ga’a": [
        644
    ],
    "ga’a-kejom": [
        644
    ],
    "golo": [
        649,
        2723
    ],
    "girawa": [
        651
    ],
    "gn": [
        666,
        792,
        947,
        1054,
        1055,
        1131,
        1139,
        1140,
        2353,
        2370,
        2437,
        2483,
        2484,
        2485,
        2672,
        2820,
        3308,
        3739,
        3740,
        3841,
        3916,
        4261,
        4376,
        4393,
        4587,
        4588,
        4589,
        4620,
        4714,
        4715,
        4866,
        5075,
        5289,
        5657,
        6054,
        7199,
        7200,
        7641,
        8729,
        8730,
        9054
    ],
    "gey": [
        2018,
        680
    ],
    "gboare": [
        683
    ],
    "guñuun ñuñ": [
        684
    ],
    "gabaden": [
        689
    ],
    "gidgid": [
        689
    ],
    "gaj": [
        696,
        2526
    ],
    "gbäyä-bogoto": [
        704
    ],
    "gbāyā ɓòkòtò": [
        704
    ],
    "gbāyā": [
        704
    ],
    "guiberoua": [
        733
    ],
    "guiberoua béte": [
        733
    ],
    "gae’": [
        756
    ],
    "gahri": [
        769,
        770
    ],
    "ghara": [
        769,
        770
    ],
    "gangai": [
        773,
        6531
    ],
    "godwani kawathi": [
        773
    ],
    "godwani": [
        773
    ],
    "gwamhi-wuri": [
        779
    ],
    "giangan": [
        786
    ],
    "guanga": [
        786
    ],
    "gulanga": [
        786
    ],
    "gbunhu": [
        798
    ],
    "got": [
        800,
        2965
    ],
    "gagauz": [
        2514,
        2515,
        2516,
        801,
        802
    ],
    "gadala": [
        827
    ],
    "ghana birifor": [
        854
    ],
    "gahom": [
        865
    ],
    "gurani": [
        2884,
        871
    ],
    "gisida": [
        925
    ],
    "gema": [
        926,
        2601,
        2860
    ],
    "goi": [
        926,
        1205
    ],
    "ghayavi": [
        954
    ],
    "galavi": [
        954
    ],
    "gamane": [
        959
    ],
    "gq": [
        979,
        984,
        1197,
        1250,
        2271,
        2332,
        2342,
        2416,
        2439,
        5568,
        5732,
        6333
    ],
    "gbang": [
        1012
    ],
    "gubanjalay": [
        1059
    ],
    "gújjolaay eegimaa": [
        1059
    ],
    "gújjolaay": [
        1059
    ],
    "guru": [
        1070,
        6621
    ],
    "galli": [
        1085,
        1086
    ],
    "gali": [
        6584,
        1085
    ],
    "gwadara basa": [
        1127
    ],
    "gwadara": [
        1127
    ],
    "gboati": [
        1144
    ],
    "gbwata": [
        1144
    ],
    "gbwate": [
        1144
    ],
    "gwate": [
        1144
    ],
    "gamo-ningi": [
        1148
    ],
    "gagnoa": [
        1150
    ],
    "gagnoa bété": [
        1150
    ],
    "gagnoua-bété": [
        1150
    ],
    "ganga": [
        1176
    ],
    "gawac": [
        1182
    ],
    "gevove": [
        1192
    ],
    "ghevove": [
        1192
    ],
    "gamba": [
        1204,
        6691
    ],
    "gumba": [
        1204
    ],
    "gu-jingarliya": [
        1213
    ],
    "gidjingaliya gujingalia": [
        1213
    ],
    "gidjingaliya": [
        1213
    ],
    "gujingalia": [
        1213
    ],
    "gujalabiya": [
        1213
    ],
    "gun-guragone": [
        1213,
        2620
    ],
    "gah": [
        1214
    ],
    "guresha": [
        1243
    ],
    "giong": [
        1257,
        4127
    ],
    "gbigbil": [
        1264
    ],
    "gang bau": [
        1281
    ],
    "gbande": [
        1296
    ],
    "gbandi": [
        1296
    ],
    "gbunde": [
        1296
    ],
    "garifuna": [
        1329
    ],
    "garífuna": [
        1329
    ],
    "guisnai": [
        1335
    ],
    "galibi": [
        1345
    ],
    "galibi carib": [
        1345
    ],
    "galibí": [
        1345
    ],
    "gayogo̱hó:nǫ’": [
        1350
    ],
    "guhaaca": [
        1377
    ],
    "galancho": [
        1405,
        1406,
        1407
    ],
    "gu": [
        2823,
        1437,
        2159
    ],
    "guam": [
        1437,
        2159
    ],
    "gbe, ci": [
        1465
    ],
    "grand couli": [
        1474
    ],
    "grand": [
        1914,
        1918,
        1925,
        1474,
        3056
    ],
    "guaga-tagare": [
        1477
    ],
    "gradišćanskohrvatski jezik": [
        1501
    ],
    "gradišćanskohrvatski": [
        1501
    ],
    "galos": [
        1517
    ],
    "goin": [
        1530
    ],
    "gouin": [
        1530
    ],
    "guin": [
        1530,
        2605
    ],
    "gwe": [
        1530
    ],
    "gwen": [
        1530
    ],
    "guìběi pínghuà": [
        1550,
        1551
    ],
    "guìběi": [
        1550,
        1551
    ],
    "guangxi": [
        8898,
        1550,
        1551,
        1645,
        1646
    ],
    "grass miao": [
        1580
    ],
    "grass": [
        3487,
        1580
    ],
    "greek": [
        2090,
        2091,
        2093,
        2764,
        2765,
        2766,
        2794,
        1587,
        2092,
        2701,
        6241,
        6242,
        6243
    ],
    "grenadines": [
        1599,
        2219,
        7217
    ],
    "girlor-kyoli": [
        1625
    ],
    "guìnán pínghuà": [
        1645,
        1646
    ],
    "guìnán": [
        1645,
        1646
    ],
    "gichuka": [
        1684
    ],
    "gĩchuka": [
        1684
    ],
    "guna": [
        1687,
        4058
    ],
    "galés": [
        1708,
        1709
    ],
    "gl": [
        1721,
        3763
    ],
    "greenland": [
        1721,
        3763
    ],
    "gwahatike": [
        1728
    ],
    "gwatike": [
        1728
    ],
    "guo garimani": [
        1732
    ],
    "guo": [
        1732,
        8785
    ],
    "garimani": [
        1732
    ],
    "gond": [
        1739,
        2287,
        2288,
        2289,
        8343,
        8344,
        8345,
        8346
    ],
    "goodenough, west": [
        1775
    ],
    "goodenough": [
        1775
    ],
    "german, standard": [
        1782,
        1785,
        1787,
        1791,
        1792
    ],
    "german": [
        1782,
        1783,
        1784,
        1785,
        1786,
        1787,
        1788,
        1789,
        1790,
        1791,
        1792,
        2572,
        2788,
        2795,
        6082,
        2692,
        2693,
        2731,
        5376,
        6086,
        8770,
        2603,
        2796,
        2797,
        5375,
        6110,
        6947,
        7953
    ],
    "germană": [
        1782,
        1785,
        1787,
        1791,
        1792
    ],
    "germany": [
        1782,
        1785,
        1787,
        1791,
        1792,
        1968,
        2142,
        2468,
        2473,
        2474,
        2692,
        2693,
        2731,
        2788,
        3058,
        3961,
        5375,
        5979,
        6110,
        6266,
        7174,
        7233,
        7264,
        8109,
        8210,
        8770,
        8798
    ],
    "gáh": [
        1804,
        1805
    ],
    "ghotie": [
        1804,
        1805
    ],
    "galu": [
        1845,
        6883
    ],
    "gabo": [
        1847
    ],
    "grande": [
        4798,
        1851,
        3562,
        5226
    ],
    "ganagana": [
        1858,
        8101
    ],
    "ganagawa": [
        1858
    ],
    "grao dima": [
        1861,
        1862
    ],
    "grao": [
        1861,
        1862
    ],
    "grau dima": [
        1861,
        1862
    ],
    "grau": [
        1861,
        1862
    ],
    "gciriku": [
        1863
    ],
    "gugu djangun": [
        1875
    ],
    "gugu": [
        2577,
        8338,
        1875,
        2671,
        2834,
        3761,
        4039,
        7869
    ],
    "gunavidji": [
        1877
    ],
    "gamsaj": [
        1880
    ],
    "gavak": [
        1898
    ],
    "gidoji": [
        1904
    ],
    "gudoji": [
        1904
    ],
    "grand valley dani": [
        1918
    ],
    "gio": [
        1919,
        1920,
        3419,
        3420
    ],
    "gio-dan": [
        1919,
        1920
    ],
    "guio": [
        1919,
        1920
    ],
    "gyo": [
        1919,
        1920
    ],
    "gam": [
        1932,
        3794,
        3795
    ],
    "guang": [
        1951,
        2410,
        2662,
        2663
    ],
    "gedeo": [
        1964
    ],
    "gebarentaal": [
        1969,
        8077
    ],
    "geleb": [
        1970
    ],
    "geleba": [
        1970
    ],
    "gheleba": [
        1970
    ],
    "gewe": [
        2018
    ],
    "gueve": [
        2018
    ],
    "gumatj": [
        2716,
        2029
    ],
    "ghangatty": [
        2037
    ],
    "gorane": [
        2047
    ],
    "garanggaba": [
        2050
    ],
    "greacă": [
        2090,
        2091,
        2093
    ],
    "grec": [
        2090,
        2091,
        2093
    ],
    "greco": [
        2090,
        2091,
        2093
    ],
    "görög": [
        2090,
        2091,
        2093
    ],
    "gf": [
        2104,
        2436,
        2571,
        9024
    ],
    "guiana": [
        2104,
        2436,
        2571,
        9024
    ],
    "gonḍi": [
        2113
    ],
    "garcia": [
        2143
    ],
    "gd": [
        2154,
        2569
    ],
    "grenada": [
        2154,
        2569
    ],
    "gg": [
        2155
    ],
    "guernsey": [
        5667,
        2155
    ],
    "gi": [
        2157
    ],
    "gibraltar": [
        2157
    ],
    "gm": [
        2158,
        2357,
        2369,
        4586,
        8310,
        8311
    ],
    "gambia": [
        2158,
        2357,
        2369,
        4586,
        8310,
        8311
    ],
    "geshitsa": [
        2251
    ],
    "geshiza": [
        2251
    ],
    "geshizahua": [
        2251
    ],
    "gyarong": [
        3449,
        2251
    ],
    "guarayo": [
        2286,
        2810,
        3267,
        7667
    ],
    "gondi, aheri": [
        2287,
        2288,
        2289
    ],
    "gondi": [
        2287,
        2288,
        2289,
        2739,
        2740,
        2741,
        8343,
        8344,
        8345,
        8346,
        2404,
        3591,
        3592,
        3593,
        3594,
        5143
    ],
    "ganawuri": [
        2314
    ],
    "galaico-extremaduran": [
        2346
    ],
    "gele": [
        2380
    ],
    "gambilmugu": [
        2400
    ],
    "guinean": [
        2820,
        2416,
        6120
    ],
    "gp": [
        2438,
        2568
    ],
    "guadeloupe": [
        2438,
        2568
    ],
    "gorgal": [
        2486,
        2487,
        2488
    ],
    "gorgal fulfulde": [
        2486,
        2487,
        2488
    ],
    "gaeilge": [
        2504,
        2505,
        2506
    ],
    "gaelic": [
        2573,
        2628,
        2504,
        2505,
        2506,
        2826
    ],
    "gaelic irish": [
        2504,
        2505,
        2506
    ],
    "gain": [
        2507,
        2508
    ],
    "gamei": [
        2507,
        2508,
        2518
    ],
    "gabri": [
        2509,
        7619
    ],
    "gabere": [
        2509
    ],
    "gaberi": [
        2509
    ],
    "gabri darbé-dormon": [
        2509
    ],
    "gabri maja": [
        2509
    ],
    "great andamanese, mixed": [
        2510
    ],
    "great": [
        2510,
        2973,
        2974,
        2975,
        4824,
        6845,
        6846,
        6847,
        6848
    ],
    "gaddang": [
        2511,
        2581
    ],
    "guarequena": [
        2512
    ],
    "guarekena": [
        2512
    ],
    "gende": [
        2513
    ],
    "gendeka": [
        2513
    ],
    "gene": [
        2513
    ],
    "gagauz dili": [
        2514,
        2515,
        2516
    ],
    "gagauzi": [
        2514,
        2515,
        2516
    ],
    "gagauzça": [
        2514,
        2515,
        2516
    ],
    "gafuku": [
        2517
    ],
    "gahuku": [
        2517
    ],
    "gahuku-asaro": [
        2517
    ],
    "gahuku-gama": [
        2517
    ],
    "gadsup": [
        2519
    ],
    "gamkonora": [
        2520
    ],
    "galolen": [
        2521
    ],
    "galole": [
        2521
    ],
    "galolem": [
        2521
    ],
    "galoleng": [
        2521
    ],
    "galoli": [
        2521
    ],
    "galolin": [
        2521
    ],
    "gan": [
        2523,
        2524,
        2525,
        2704,
        2712,
        8835,
        8858
    ],
    "gan chinese": [
        2523,
        2524,
        2525
    ],
    "gants": [
        2526
    ],
    "ganj": [
        2526
    ],
    "gal": [
        2527
    ],
    "gata’": [
        2528
    ],
    "gata'": [
        2528
    ],
    "gataq": [
        2528
    ],
    "getaq": [
        2528
    ],
    "geta’": [
        2528
    ],
    "gta asa": [
        2528
    ],
    "gta": [
        2528
    ],
    "gta’": [
        2528
    ],
    "galeya": [
        2529
    ],
    "garea": [
        2529
    ],
    "garasia, adiwasi": [
        2530
    ],
    "garasia": [
        2530,
        2761,
        2762
    ],
    "girasia": [
        2761,
        2762,
        2530
    ],
    "gujarati": [
        2800,
        2801,
        2802,
        2530,
        2659,
        2660
    ],
    "ganati": [
        2531
    ],
    "gadaba, mudhili": [
        2532
    ],
    "gadaba": [
        2532,
        2548,
        2575,
        2576,
        6074
    ],
    "gol gadaba": [
        2532
    ],
    "gol": [
        2532
    ],
    "garuh": [
        2533
    ],
    "guji": [
        2537
    ],
    "gayo": [
        2538
    ],
    "gajo": [
        2538
    ],
    "gayonese": [
        2538
    ],
    "gbaya (central african republic)": [
        2539,
        2540
    ],
    "gbaya": [
        2539,
        2540,
        2792,
        3942,
        2555,
        2556,
        5421
    ],
    "gbaya nord-ouest": [
        2539
    ],
    "gbaya, northwest": [
        2539
    ],
    "gaididj": [
        2541
    ],
    "garadjari": [
        2542
    ],
    "garadjiri": [
        2542
    ],
    "garadyari": [
        2542
    ],
    "gard’are": [
        2542
    ],
    "guradjara": [
        2542
    ],
    "gaikundi": [
        2544,
        6755
    ],
    "gaikunti": [
        2544
    ],
    "gbanziri": [
        2545
    ],
    "gbandere": [
        2545
    ],
    "gbanzili": [
        2545
    ],
    "gbe, defi": [
        2546
    ],
    "galela": [
        2547
    ],
    "galelaka": [
        2547
    ],
    "gadaba, bodo": [
        2548
    ],
    "gadba": [
        2548,
        2575,
        2576
    ],
    "gadwa": [
        2548
    ],
    "godwa": [
        2548
    ],
    "gudwa": [
        2548
    ],
    "gutob": [
        2548
    ],
    "gutop": [
        2548
    ],
    "gaddi": [
        2549,
        2550
    ],
    "gaddyali": [
        2549,
        2550
    ],
    "gadi": [
        2549,
        2550
    ],
    "gadiali": [
        2549,
        2550
    ],
    "gamit": [
        2551,
        2552
    ],
    "gamati": [
        2551,
        2552
    ],
    "gameti": [
        2551,
        2552
    ],
    "gamith": [
        2551,
        2552
    ],
    "gamta": [
        2551,
        2552
    ],
    "gamti": [
        2551,
        2552
    ],
    "gavit": [
        2551,
        2552
    ],
    "garhwali": [
        2553
    ],
    "gadhavali": [
        2553
    ],
    "gadhawala": [
        2553
    ],
    "gadwahi": [
        2553
    ],
    "gashwali": [
        2553
    ],
    "girwali": [
        2553
    ],
    "godauli": [
        2553
    ],
    "gorwali": [
        2553
    ],
    "gurvali": [
        2553
    ],
    "gbara": [
        2554
    ],
    "gberi": [
        2554
    ],
    "gweri": [
        2554
    ],
    "gbaya-bossangoa": [
        2555
    ],
    "gbaya de bosangoa": [
        2555
    ],
    "gbaya of borro": [
        2555
    ],
    "gbaya of bossangoa": [
        2555
    ],
    "gbaya-borro": [
        2555
    ],
    "gbea": [
        2555
    ],
    "gbeya": [
        2555
    ],
    "gbäyä bossangoa": [
        2555
    ],
    "gbäyä": [
        3942,
        2555
    ],
    "gbɛa": [
        2555
    ],
    "gbɛya": [
        2555
    ],
    "gbɛ́yá": [
        2555
    ],
    "gbaya-bozoum": [
        2556
    ],
    "gbaya de bozoum": [
        2556
    ],
    "gbagyi": [
        2557
    ],
    "gwari": [
        2563,
        2557
    ],
    "gbagye": [
        2557
    ],
    "gwari matai": [
        2557
    ],
    "gbe, gbesi": [
        2558
    ],
    "gbesi": [
        2558
    ],
    "gbesi gbe": [
        2558
    ],
    "gagadu": [
        2559
    ],
    "gaagudju": [
        2559
    ],
    "gagadju": [
        2559
    ],
    "gagudju": [
        2559
    ],
    "gbanu": [
        2560
    ],
    "gbanou": [
        2560
    ],
    "gabi-gabi": [
        2561
    ],
    "gabi": [
        2561
    ],
    "gabigabi": [
        2561
    ],
    "gubbi gubbi": [
        2561
    ],
    "gubbi": [
        2561
    ],
    "gbe, eastern xwla": [
        2562
    ],
    "gbari": [
        2563
    ],
    "gbari yamma": [
        2563
    ],
    "gwari yamma": [
        2563
    ],
    "gaktai": [
        2565
    ],
    "ganggalida": [
        2566
    ],
    "ganggalita": [
        2566
    ],
    "galice": [
        2567
    ],
    "guadeloupean french creole": [
        2568
    ],
    "guadeloupean": [
        2568
    ],
    "guadeloupean creole": [
        2568
    ],
    "guadeloupean creole french": [
        2568
    ],
    "grenadian english creole": [
        2569
    ],
    "grenadian": [
        2569
    ],
    "grenadian creole english": [
        2569
    ],
    "gaina": [
        2570
    ],
    "guianese french creole": [
        2571
    ],
    "guianese": [
        2571
    ],
    "guianese creole french": [
        2571
    ],
    "guyanais": [
        2571
    ],
    "guyane": [
        2571
    ],
    "guyane creole": [
        2571
    ],
    "german, colonia tovar": [
        2572
    ],
    "gàidhlig": [
        2573
    ],
    "gàidhlig albannach": [
        2573
    ],
    "gàidhlig na h-alba": [
        2573
    ],
    "gade": [
        2600,
        2574
    ],
    "gade lohar": [
        2574
    ],
    "gadia lohar": [
        2574
    ],
    "gadia": [
        2574
    ],
    "gaduliya lohar": [
        2574
    ],
    "gaduliya": [
        2574
    ],
    "gara": [
        2574
    ],
    "gadaba, pottangi ollar": [
        2575,
        2576
    ],
    "gadbas": [
        2575,
        2576
    ],
    "gugu badhun": [
        2577
    ],
    "gugu-badhun": [
        2577
    ],
    "gedaged": [
        2578
    ],
    "graged": [
        2578
    ],
    "gude": [
        2579
    ],
    "guɗe": [
        2579
    ],
    "goude": [
        2579
    ],
    "goudé": [
        2579
    ],
    "guduf-gava": [
        2580
    ],
    "gudupe": [
        2580
    ],
    "ga’dang": [
        2581
    ],
    "gaꞌdang": [
        2581
    ],
    "ga'dang": [
        2581
    ],
    "ginabwal": [
        2581
    ],
    "gadjerawang": [
        2582
    ],
    "gadjerong": [
        2582
    ],
    "gadjerrong": [
        2582
    ],
    "gadyerong": [
        2582
    ],
    "gajerrong": [
        2582
    ],
    "gajirrabeng": [
        2582
    ],
    "gajirrawoong": [
        2582
    ],
    "gundi": [
        2583
    ],
    "gurdjar": [
        2584
    ],
    "goom-gharra": [
        2584
    ],
    "gunggara": [
        2584
    ],
    "gadang": [
        2585,
        3532
    ],
    "gori": [
        2588
    ],
    "gvede": [
        2589
    ],
    "gweda": [
        2783,
        2589
    ],
    "gwede": [
        2589
    ],
    "gwedena": [
        2589
    ],
    "ghodoberi": [
        2590
    ],
    "godoberi": [
        2590
    ],
    "godoberin": [
        2590
    ],
    "ghandruk sign language": [
        2593
    ],
    "ghandruk": [
        2593
    ],
    "gungadidji": [
        2594
    ],
    "gungadudji": [
        2594
    ],
    "gunganndji": [
        2594
    ],
    "gudu": [
        2595
    ],
    "gudo": [
        2595
    ],
    "gutu": [
        2595
    ],
    "godwari": [
        2596
    ],
    "geruma": [
        2597
    ],
    "geerum": [
        2597
    ],
    "gerema": [
        2597
    ],
    "germa": [
        2597
    ],
    "gyeermu": [
        2597
    ],
    "gire": [
        2598
    ],
    "giri": [
        2598
    ],
    "grebo, gboloo": [
        2599
    ],
    "grebo": [
        2599,
        2763,
        2771,
        2782,
        2785
    ],
    "gboloo": [
        2599
    ],
    "gblou grebo": [
        2599
    ],
    "gblou": [
        2599
    ],
    "gboloo grebo": [
        2599
    ],
    "gede": [
        2600
    ],
    "gerai": [
        2601
    ],
    "gorai": [
        2601
    ],
    "gengle": [
        2602
    ],
    "german, hutterite": [
        2603
    ],
    "gebe": [
        2604,
        2605
    ],
    "gebi": [
        2604
    ],
    "gen": [
        2605,
        9181
    ],
    "gen-gbe": [
        2605
    ],
    "gegbe": [
        2605
    ],
    "gɛgbe": [
        2605
    ],
    "garkawa": [
        2606
    ],
    "gerka": [
        2606
    ],
    "gerkanchi": [
        2606
    ],
    "gerkawa": [
        2606
    ],
    "gurka": [
        2606
    ],
    "gelanchi": [
        2607
    ],
    "geme": [
        2608
    ],
    "gueme": [
        2608
    ],
    "geser-gorom": [
        2609
    ],
    "gesa": [
        2609
    ],
    "geser": [
        2609
    ],
    "goram": [
        2609
    ],
    "goran": [
        2609,
        6893
    ],
    "gorom": [
        2609
    ],
    "gorong": [
        2609
    ],
    "gevia": [
        2610
    ],
    "geviya": [
        2610
    ],
    "gera": [
        2611
    ],
    "gerawa": [
        2611
    ],
    "garre": [
        2612
    ],
    "garreh": [
        2612
    ],
    "gurreh": [
        2612
    ],
    "genya": [
        2613
    ],
    "geez": [
        2614
    ],
    "gelik": [
        2615
    ],
    "gafat": [
        2616
    ],
    "gao": [
        2617,
        2760,
        6792
    ],
    "gbii": [
        2618
    ],
    "gbee": [
        2618
    ],
    "gbi-dowlu": [
        2618
    ],
    "gugadj": [
        2619
    ],
    "gurr-goni": [
        2620
    ],
    "gorogone": [
        2620
    ],
    "gunagoragone": [
        2620
    ],
    "gungorogone": [
        2620
    ],
    "guragone": [
        2620
    ],
    "gurrogone": [
        2620
    ],
    "gutjertabia": [
        2620
    ],
    "gurgula": [
        2621
    ],
    "ghera": [
        2635,
        2621
    ],
    "gunerakan": [
        2622
    ],
    "gungaragan": [
        2622
    ],
    "gungaragany": [
        2622
    ],
    "gungarakanj": [
        2622
    ],
    "gungarakayn": [
        2622
    ],
    "ganglau": [
        2623
    ],
    "gitua": [
        2624
    ],
    "gitoa": [
        2624
    ],
    "gban": [
        2625
    ],
    "gagou": [
        2625
    ],
    "gagu": [
        2625
    ],
    "gogodala": [
        2626
    ],
    "gogodara": [
        2626
    ],
    "ghadamès": [
        2627
    ],
    "ghadames": [
        2627
    ],
    "ghadāmis": [
        2627
    ],
    "ghale, southern": [
        2629
    ],
    "ghale": [
        2629,
        2630,
        2637
    ],
    "galle gurung": [
        2629
    ],
    "galle": [
        2629
    ],
    "gurung": [
        2837,
        2838,
        2629
    ],
    "ghale, northern": [
        2630
    ],
    "geko": [
        2631
    ],
    "gaikho": [
        2631
    ],
    "gekho": [
        2631
    ],
    "geko karen": [
        2631
    ],
    "gek’o": [
        2631
    ],
    "ghekhol": [
        2631
    ],
    "ghekhu": [
        2631
    ],
    "gheko": [
        2631
    ],
    "ghulfan": [
        2632
    ],
    "gulfan": [
        2632
    ],
    "ghanongga": [
        2633
    ],
    "ganoga": [
        2633
    ],
    "ganongga": [
        2633
    ],
    "ghomara": [
        2634
    ],
    "guhu-samane": [
        2636
    ],
    "guhu-samane noo": [
        2636
    ],
    "gidja": [
        2638
    ],
    "gibanawa": [
        2639
    ],
    "gembanawa": [
        2639
    ],
    "gimbanawa": [
        2639
    ],
    "gail": [
        2640
    ],
    "gidar": [
        2641
    ],
    "gidder": [
        2641
    ],
    "guidar": [
        2641
    ],
    "guider": [
        2641
    ],
    "guébie": [
        2642
    ],
    "gaɓogbo": [
        2642
    ],
    "goaria": [
        2643
    ],
    "githabul": [
        2644
    ],
    "gidabal": [
        2644
    ],
    "gidabul": [
        2644
    ],
    "gidhabal": [
        2644
    ],
    "gidjoobal": [
        2644
    ],
    "girirra": [
        2645
    ],
    "gilbertese": [
        2646
    ],
    "gimi": [
        2647,
        2649
    ],
    "gimi (eastern highlands)": [
        2647
    ],
    "ginukh": [
        2648
    ],
    "ginukhtsy": [
        2648
    ],
    "ginux": [
        2648
    ],
    "gimi (west new britain)": [
        2649
    ],
    "gelao, green": [
        2650
    ],
    "gelao": [
        2650,
        2651,
        2654,
        2655,
        2760
    ],
    "green gelao": [
        2650
    ],
    "gelao, red": [
        2651
    ],
    "giziga, north": [
        2652
    ],
    "giziga": [
        2652,
        2658
    ],
    "gisiga": [
        2652,
        2658
    ],
    "gisika": [
        2652,
        2658
    ],
    "giziga de": [
        2652
    ],
    "guiziga": [
        2652,
        2658
    ],
    "gitxsan": [
        2653
    ],
    "giklsan": [
        2653
    ],
    "gitksan": [
        2653
    ],
    "gitsenimx": [
        2653
    ],
    "gitxsen": [
        2653
    ],
    "gityskyan": [
        2653
    ],
    "gelo": [
        2760,
        2655
    ],
    "gelao, white": [
        2655
    ],
    "gilima": [
        2656
    ],
    "giyug": [
        2657
    ],
    "gunditjmara": [
        2661
    ],
    "gournditch-mara": [
        2661
    ],
    "gundidj": [
        2661
    ],
    "gurnditschmara": [
        2661
    ],
    "gonja": [
        2662,
        2663
    ],
    "gurindji kriol": [
        2664
    ],
    "gurindji": [
        2664,
        2807
    ],
    "gurindji children’s language": [
        2664
    ],
    "gurinji": [
        2664,
        2807
    ],
    "gurinji kriol": [
        2664
    ],
    "gujari": [
        2665,
        2666,
        3655
    ],
    "gogri": [
        2665,
        2666
    ],
    "gojari": [
        2665,
        2666
    ],
    "gojri": [
        2665,
        2666
    ],
    "gujar": [
        2665,
        2666
    ],
    "gujer": [
        2665,
        2666
    ],
    "gujjari": [
        2665,
        2666
    ],
    "gujuri": [
        2665,
        2666
    ],
    "gujuri rajasthani": [
        2665,
        2666
    ],
    "gurjar": [
        2665,
        2666
    ],
    "guya": [
        2667
    ],
    "guiarak": [
        2667
    ],
    "guyarak": [
        2667
    ],
    "galke": [
        2669
    ],
    "gokana": [
        2670
    ],
    "gog nar": [
        2671
    ],
    "gog": [
        2671,
        7460
    ],
    "goondarra": [
        2671
    ],
    "gugu nar": [
        2671
    ],
    "gugu nhang": [
        2671
    ],
    "gundara": [
        2671
    ],
    "gbese": [
        2672,
        3877,
        3878
    ],
    "gerse": [
        2672
    ],
    "gerze": [
        2672
    ],
    "guerzé": [
        2672
    ],
    "guinea kpelle": [
        2672
    ],
    "galician": [
        2674
    ],
    "galego": [
        2674
    ],
    "gallego": [
        2674
    ],
    "gula": [
        2679,
        2685,
        3518,
        2676,
        9107,
        2735
    ],
    "goula": [
        2679,
        2685,
        3518,
        9107,
        2676
    ],
    "gula guera": [
        2676,
        9107
    ],
    "guera": [
        2676,
        4983,
        9107
    ],
    "gold": [
        2677
    ],
    "goldi": [
        2677
    ],
    "gula iro": [
        2679
    ],
    "goula iro": [
        2679
    ],
    "goula d’iro": [
        2679
    ],
    "gilaki": [
        2680,
        2681,
        5269
    ],
    "gelaki": [
        2680,
        2681
    ],
    "gilani": [
        2680,
        2681
    ],
    "guilaki": [
        2680,
        2681
    ],
    "guilani": [
        2680,
        2681
    ],
    "garlali": [
        2682
    ],
    "galali": [
        2682
    ],
    "galambu": [
        2683
    ],
    "galambe": [
        2683
    ],
    "galambi": [
        2683
    ],
    "galembi": [
        2683
    ],
    "glaro-twabo": [
        2684
    ],
    "gula (chad)": [
        2685
    ],
    "glavda": [
        2686
    ],
    "galavda": [
        2686
    ],
    "galvaxdaxa": [
        2686
    ],
    "gelebda": [
        2686
    ],
    "gelvaxdaxa": [
        2686
    ],
    "glanda": [
        2686
    ],
    "guelebda": [
        2686
    ],
    "gule": [
        2687
    ],
    "gambera": [
        2688
    ],
    "gamberre": [
        2688
    ],
    "gambre": [
        2688
    ],
    "gamgre": [
        2688
    ],
    "guwan": [
        2688
    ],
    "gula’alaa": [
        2689
    ],
    "gula'alaa": [
        2689
    ],
    "gbaya-mbodomo": [
        2694
    ],
    "gimnime": [
        2695
    ],
    "gimbe": [
        2695
    ],
    "gumalu": [
        2697
    ],
    "gamo": [
        2698,
        2699,
        5316
    ],
    "gamotso": [
        2699
    ],
    "guarani": [
        2703
    ],
    "guaraní": [
        2721,
        2810,
        2815,
        5448,
        2703
    ],
    "guaraní paraguaio": [
        2703
    ],
    "guaraní, paraguayan": [
        2703
    ],
    "gane": [
        2873,
        2704
    ],
    "gã": [
        2704
    ],
    "gangte": [
        2705
    ],
    "gante": [
        2705
    ],
    "guanche": [
        2706
    ],
    "gemzek": [
        2707
    ],
    "gemjek": [
        2707
    ],
    "guemjek": [
        2707
    ],
    "guemshek": [
        2707
    ],
    "guemzek": [
        2707
    ],
    "ganang": [
        2708
    ],
    "gashish": [
        2708
    ],
    "gamgan": [
        2709
    ],
    "gando": [
        2709,
        8490
    ],
    "gangam": [
        2709
    ],
    "gangum": [
        2709
    ],
    "gooniyandi": [
        2711
    ],
    "goonien": [
        2711
    ],
    "gunan": [
        2711
    ],
    "gunian": [
        2711
    ],
    "guniandi": [
        2711
    ],
    "guniyan": [
        2711
    ],
    "guniyandi": [
        2711
    ],
    "guniyn": [
        2711
    ],
    "gxana": [
        2713
    ],
    "gxanna": [
        2713
    ],
    "gǁana": [
        2713
    ],
    "gǁana-khwe": [
        2713
    ],
    "gangulu": [
        2714,
        5444
    ],
    "ginuman": [
        2715
    ],
    "gomadj": [
        2716
    ],
    "gumait": [
        2716
    ],
    "gumaj": [
        2716
    ],
    "gana": [
        2717
    ],
    "ganaq": [
        2717
    ],
    "gana’": [
        2717
    ],
    "ganna": [
        2717
    ],
    "gureng gureng": [
        2718
    ],
    "gureng": [
        2718
    ],
    "ginginburra": [
        2718
    ],
    "goorang-goorang": [
        2718
    ],
    "gooranggorang": [
        2718
    ],
    "gooreng gooreng": [
        2718
    ],
    "gooreng": [
        2718
    ],
    "goreng goreng": [
        2718
    ],
    "goreng": [
        8465,
        2718
    ],
    "goreng-goreng": [
        2718
    ],
    "gurang": [
        2718
    ],
    "gurang gurang": [
        2718
    ],
    "gurang-gurang": [
        2718
    ],
    "guranggurang": [
        2718
    ],
    "gureng-gureng": [
        2718
    ],
    "gurreng gurreng": [
        2718
    ],
    "gurreng": [
        2718
    ],
    "guntai": [
        2719
    ],
    "gnau": [
        2720
    ],
    "guaraní, western bolivian": [
        2721
    ],
    "ganzi": [
        2722
    ],
    "guro": [
        2723
    ],
    "gouro": [
        2723
    ],
    "guahibo playero": [
        2724
    ],
    "guahibo": [
        2809,
        2724,
        4612
    ],
    "gorakor": [
        2725
    ],
    "godié": [
        2726
    ],
    "godye": [
        2726
    ],
    "gongduk": [
        2727
    ],
    "gongdubikha": [
        2727
    ],
    "gofa": [
        2728,
        2729
    ],
    "goofatho": [
        2729
    ],
    "gogo": [
        2730
    ],
    "gebusi": [
        2732
    ],
    "gobasi": [
        2732
    ],
    "gowlan": [
        2733
    ],
    "gowli": [
        2734
    ],
    "gola": [
        2735,
        6054,
        5891
    ],
    "goan": [
        2736,
        2737,
        2738
    ],
    "goan konkani": [
        2736,
        2737,
        2738
    ],
    "goanese konkani": [
        2736,
        2737,
        2738
    ],
    "goanese": [
        2736,
        2737,
        2738
    ],
    "gomataki": [
        2736,
        2737,
        2738
    ],
    "gaudi": [
        2740,
        2741
    ],
    "ghond": [
        2740,
        2741
    ],
    "godi": [
        2740,
        2741
    ],
    "gondi, northern": [
        2740,
        2741
    ],
    "gondiva": [
        2740,
        2741
    ],
    "gondu": [
        2740,
        2741
    ],
    "gondwadi": [
        2740,
        2741
    ],
    "goondile": [
        2740,
        2741
    ],
    "goudi": [
        2740,
        2741
    ],
    "goudwal": [
        2740,
        2741
    ],
    "gone dau": [
        2742
    ],
    "gone": [
        2742
    ],
    "gonedau": [
        2742
    ],
    "goni": [
        2743
    ],
    "gorap": [
        2744
    ],
    "gorontalo": [
        2745
    ],
    "gorongtalo": [
        2745
    ],
    "guarantala": [
        2745
    ],
    "gunongtello": [
        2745
    ],
    "gronings": [
        2746
    ],
    "groningen": [
        2746
    ],
    "grunnegs": [
        2746
    ],
    "grunnings": [
        2746
    ],
    "grönnegs": [
        2746
    ],
    "gothic": [
        2747
    ],
    "gavar": [
        2748
    ],
    "gauar": [
        2748
    ],
    "gawar": [
        2748
    ],
    "gaware": [
        2748
    ],
    "gouwar": [
        2748
    ],
    "gorowa": [
        2749
    ],
    "goroa": [
        2749
    ],
    "gorwaa": [
        2749
    ],
    "gobu": [
        2750
    ],
    "gabou": [
        2750
    ],
    "gabu": [
        2750
    ],
    "gubu": [
        2750
    ],
    "goundo": [
        2751
    ],
    "gozarkhani": [
        2752
    ],
    "gozärkhon": [
        2752
    ],
    "gupa-abawa": [
        2753
    ],
    "ghanaian pidgin english": [
        2754
    ],
    "ghanaian": [
        2754,
        2787
    ],
    "gapun": [
        2755
    ],
    "ga’anda": [
        2756
    ],
    "ga'anda": [
        2756
    ],
    "ganda": [
        4296,
        4297,
        2756
    ],
    "ga’ana": [
        2756
    ],
    "ga’andu": [
        2756
    ],
    "guiqiong": [
        2757
    ],
    "guichong": [
        2757
    ],
    "guiqiang": [
        2757
    ],
    "guana": [
        2758,
        2827
    ],
    "guana (brazil)": [
        2758
    ],
    "guaná": [
        2758
    ],
    "gor": [
        2759
    ],
    "gao gelao": [
        2760
    ],
    "garasia, rajput": [
        2761,
        2762
    ],
    "grasia": [
        2761,
        2762
    ],
    "grebo, northern": [
        2763
    ],
    "greek, ancient": [
        2764,
        2765,
        2766
    ],
    "guruntum-mbaaru": [
        2767
    ],
    "gurdung": [
        2767
    ],
    "guruntum": [
        2767
    ],
    "gira": [
        2768
    ],
    "girara": [
        2768
    ],
    "gbiri-niragu": [
        2769
    ],
    "gure-kahugu": [
        2769
    ],
    "ghari": [
        2770
    ],
    "gari": [
        2770
    ],
    "guadalcanal": [
        2770
    ],
    "grebo, southern": [
        2771
    ],
    "groma": [
        2773
    ],
    "gromo": [
        2773
    ],
    "gorovu": [
        2774
    ],
    "gorova": [
        2774
    ],
    "gresi": [
        2776
    ],
    "geresi": [
        2776
    ],
    "glesi": [
        2776
    ],
    "gresik": [
        2776
    ],
    "garo": [
        2777,
        2778,
        2779
    ],
    "garrow": [
        2777,
        2778,
        2779
    ],
    "grebo, central": [
        2782
    ],
    "garuwahi": [
        2783
    ],
    "guriaso": [
        2784
    ],
    "grebo, barclayville": [
        2785
    ],
    "guramalum": [
        2786
    ],
    "ghanaian sign language": [
        2787
    ],
    "gsl": [
        2787,
        2794
    ],
    "german sign language": [
        2788
    ],
    "gusilay": [
        2789
    ],
    "gusiilaay": [
        2789
    ],
    "gusiilay": [
        2789
    ],
    "gusilaay": [
        2789
    ],
    "guatemalan sign language": [
        2790
    ],
    "guatemalan": [
        2790
    ],
    "gsm": [
        2790
    ],
    "gusan": [
        2791
    ],
    "gbaya, southwest": [
        2792
    ],
    "gbaya sud-ouest": [
        2792
    ],
    "gusap": [
        2793
    ],
    "greek sign language": [
        2794
    ],
    "glossa": [
        2794
    ],
    "german, swiss": [
        2795
    ],
    "guató": [
        2798
    ],
    "gujerathi": [
        2800,
        2801,
        2802
    ],
    "gujerati": [
        2800,
        2801,
        2802
    ],
    "gujrathi": [
        2800,
        2801,
        2802
    ],
    "guba": [
        2803,
        4553
    ],
    "gubawa": [
        2803
    ],
    "gubi": [
        2803
    ],
    "guajajára": [
        2804
    ],
    "guazazzara": [
        2804
    ],
    "goajiro": [
        2805
    ],
    "guajira": [
        2805
    ],
    "guajiro": [
        2805
    ],
    "gupapuyngu": [
        2808
    ],
    "gobabingo": [
        2808
    ],
    "gubabwingu": [
        2808
    ],
    "goahibo": [
        2809
    ],
    "goahiva": [
        2809
    ],
    "guaigua": [
        2809
    ],
    "guajibo": [
        2809
    ],
    "guayba": [
        2809
    ],
    "guaraní, eastern bolivian": [
        2810
    ],
    "guaraní occidental": [
        2810
    ],
    "guaraní pe": [
        2810
    ],
    "guaraní, western argentine": [
        2810
    ],
    "guasurango": [
        2810,
        7667
    ],
    "gumuz": [
        2811,
        2812
    ],
    "gullah": [
        2813
    ],
    "geechee": [
        2813
    ],
    "guambiano": [
        2814
    ],
    "guambia": [
        2814
    ],
    "guanaca": [
        2814
    ],
    "guaraní, mbyá": [
        2815
    ],
    "guayabero": [
        2816
    ],
    "gunwinggu": [
        2817
    ],
    "gun-wok": [
        2817
    ],
    "gunawitji": [
        2817
    ],
    "gunwinjgu": [
        2817
    ],
    "gunwinygu": [
        2817
    ],
    "gurene": [
        2819
    ],
    "gurenne": [
        2819
    ],
    "gurenɛ": [
        2819
    ],
    "gurne": [
        2819
    ],
    "gurune": [
        2819
    ],
    "gʋrnɛ ninkãrɛ": [
        2819
    ],
    "gʋrnɛ": [
        2819
    ],
    "guinean sign language": [
        2820
    ],
    "guatuso": [
        2821
    ],
    "guaharibo": [
        2822
    ],
    "guaica": [
        2822
    ],
    "guajaribo": [
        2822
    ],
    "gun": [
        2823,
        6476
    ],
    "gungbe": [
        2823
    ],
    "goun": [
        2823
    ],
    "gugbe": [
        2823
    ],
    "gun-alada": [
        2823
    ],
    "gun-gbe": [
        2823
    ],
    "gourmanchéma": [
        2824
    ],
    "gourma": [
        2824
    ],
    "goulimancema": [
        2824
    ],
    "goulmacema": [
        2824
    ],
    "goulmancema": [
        2824
    ],
    "gourmantche": [
        2824
    ],
    "gulimancema": [
        2824
    ],
    "gulmancema": [
        2824
    ],
    "gurma": [
        2824
    ],
    "gusii": [
        2825
    ],
    "guzii": [
        2825
    ],
    "gaelg": [
        2826
    ],
    "gailck": [
        2826
    ],
    "guana (paraguay)": [
        2827
    ],
    "guanano": [
        2828
    ],
    "guwet": [
        2829
    ],
    "guwot": [
        2829
    ],
    "golin": [
        2830
    ],
    "golin ka": [
        2830
    ],
    "gollum": [
        2830
    ],
    "gumine": [
        2830
    ],
    "guajá": [
        2831
    ],
    "guaxare": [
        2831
    ],
    "gulay": [
        2832
    ],
    "goulai": [
        2832
    ],
    "goulaye": [
        2832
    ],
    "goulei": [
        2832
    ],
    "gouley": [
        2832
    ],
    "gulai": [
        2832
    ],
    "gulei": [
        2832
    ],
    "guley": [
        2832
    ],
    "gurmana": [
        2833
    ],
    "gugu yalandyi": [
        2834
    ],
    "gugu yalanji": [
        2834
    ],
    "guguyalanji": [
        2834
    ],
    "gavião do jiparaná": [
        2835
    ],
    "gavião": [
        2835,
        2836
    ],
    "gavião do rondônia": [
        2835
    ],
    "gavião, pará": [
        2836
    ],
    "gavião perkatêjê": [
        2836
    ],
    "gavião do mãe maria": [
        2836
    ],
    "gavião do pará": [
        2836
    ],
    "gurung kura": [
        2837,
        2838
    ],
    "gumawana": [
        2839
    ],
    "gumasi": [
        2839
    ],
    "gumasila": [
        2839
    ],
    "guyani": [
        2840
    ],
    "gujani": [
        2840
    ],
    "goaa": [
        2841
    ],
    "gwa": [
        2842,
        2841,
        2856
    ],
    "gawri": [
        2843
    ],
    "gaawro": [
        2843
    ],
    "garwa": [
        2843
    ],
    "garwi": [
        2843
    ],
    "gowri": [
        2843
    ],
    "gweno": [
        2845
    ],
    "ghonu": [
        2845
    ],
    "gowro": [
        2846
    ],
    "gabar khel": [
        2846
    ],
    "gabar": [
        2846
    ],
    "gabaro": [
        2846
    ],
    "gomu": [
        2847
    ],
    "gwom": [
        2847
    ],
    "gwomo": [
        2847
    ],
    "gwomu": [
        2847
    ],
    "gwich’in": [
        2848
    ],
    "gwichʼin": [
        2848
    ],
    "g!wikwe": [
        2849
    ],
    "gcwi": [
        2849
    ],
    "gǀwi": [
        2849
    ],
    "gǀwikhwe": [
        2849
    ],
    "gwandara": [
        2851
    ],
    "gwere": [
        2852
    ],
    "gawar-bati": [
        2853
    ],
    "gowar-bati": [
        2853
    ],
    "gowari": [
        2853
    ],
    "guwamu": [
        2854
    ],
    "guamu": [
        2854
    ],
    "goonan": [
        2855
    ],
    "gunin": [
        2855
    ],
    "gwiini": [
        2855
    ],
    "gwini": [
        2855
    ],
    "gua": [
        2856,
        4209
    ],
    "guan": [
        2856,
        7894
    ],
    "guéré": [
        8203,
        2857
    ],
    "gere": [
        2857,
        8203
    ],
    "garus": [
        2858
    ],
    "gajadilt": [
        2859
    ],
    "gajardild": [
        2859
    ],
    "gayadilt": [
        2859
    ],
    "gayardild": [
        2859
    ],
    "gayardilt": [
        2859
    ],
    "gyem": [
        2860,
        6385
    ],
    "gemawa": [
        2860
    ],
    "gyam": [
        2860
    ],
    "gyemawa": [
        2860
    ],
    "gungabula": [
        2861
    ],
    "gbayi": [
        2862
    ],
    "gyele": [
        2863
    ],
    "giele": [
        2863
    ],
    "gieli": [
        2863
    ],
    "gyeli": [
        2863
    ],
    "gayil": [
        2864
    ],
    "guaymí": [
        2865
    ],
    "guyanese english creole": [
        2866
    ],
    "guyanese": [
        2866,
        3013
    ],
    "gaiyniiz": [
        2866
    ],
    "guyanese creole": [
        2866
    ],
    "guyanese creole english": [
        2866
    ],
    "gyalsumdo": [
        2867
    ],
    "guarayu": [
        2868
    ],
    "guapore": [
        2868
    ],
    "gunya": [
        2869
    ],
    "gyaazi": [
        2870
    ],
    "gaejawa": [
        2870
    ],
    "gejawa": [
        2870
    ],
    "geji": [
        2870
    ],
    "gezawa": [
        2870
    ],
    "ganza": [
        2871
    ],
    "ganzo": [
        2871
    ],
    "gwami": [
        2871,
        8355
    ],
    "gazi": [
        2872
    ],
    "gani": [
        2873
    ],
    "giman": [
        2873
    ],
    "gorani": [
        2884
    ],
    "guangdonghua": [
        2893,
        2894,
        2895
    ],
    "giha": [
        2901
    ],
    "garaghwaghi": [
        2929
    ],
    "gbuhwe": [
        2937
    ],
    "gabake-ntshori": [
        2950
    ],
    "gǁabake": [
        2950
    ],
    "great flowery tribe": [
        2973,
        2974,
        2975
    ],
    "guiyang": [
        2978,
        2996,
        3080
    ],
    "gaopo": [
        2980
    ],
    "ge jia": [
        2981
    ],
    "ge-mong": [
        2981
    ],
    "gedang": [
        2981
    ],
    "gedong": [
        2981
    ],
    "gedou": [
        2981
    ],
    "gedou miao": [
        2981
    ],
    "gedoudiu": [
        2981
    ],
    "gedu": [
        2981
    ],
    "gejia": [
        2981
    ],
    "gho-mhon": [
        2981
    ],
    "guizhou": [
        2986
    ],
    "gha ne": [
        2986
    ],
    "gha": [
        2986
    ],
    "gha ne dlai": [
        2986
    ],
    "green hmong": [
        3005,
        3006,
        3007,
        3008,
        3009
    ],
    "green meo": [
        3008
    ],
    "gaili": [
        3013
    ],
    "guyanese hindustani": [
        3013
    ],
    "guha": [
        3031
    ],
    "gohllaru": [
        3038
    ],
    "golari-kannada": [
        3038
    ],
    "gusso": [
        3054
    ],
    "ghunzib": [
        3095
    ],
    "gunzib": [
        3095
    ],
    "ghye": [
        3106
    ],
    "gepmakudi": [
        3112
    ],
    "gepma kwudi": [
        3112
    ],
    "gepma": [
        3112
    ],
    "gepma kwundi": [
        3112
    ],
    "gilipanes": [
        3150
    ],
    "garig-ilgar": [
        3194
    ],
    "gestuno": [
        3202
    ],
    "galgay": [
        3215,
        3216,
        3217
    ],
    "ghalghaj": [
        3215,
        3216,
        3217
    ],
    "ghalghay": [
        3215,
        3216,
        3217
    ],
    "giudeo-italiano": [
        3269
    ],
    "goenpul": [
        3316
    ],
    "goinbal": [
        3316
    ],
    "gonjbal": [
        3316
    ],
    "gokulu mana dhanguny’ bulthun": [
        3323
    ],
    "gokulu": [
        3323
    ],
    "gie": [
        3346,
        3347
    ],
    "gwak": [
        3358
    ],
    "gingwak": [
        3358
    ],
    "gevou": [
        3372
    ],
    "guanyingqiao": [
        3373
    ],
    "guanyinqiao": [
        3373
    ],
    "gia rai": [
        3419,
        3420
    ],
    "gia": [
        3419,
        3420,
        7858
    ],
    "gia-rai": [
        3419,
        3420
    ],
    "gio rai": [
        3419,
        3420
    ],
    "gio-rai": [
        3419,
        3420
    ],
    "gengo": [
        3425
    ],
    "gwira": [
        3448
    ],
    "gyarung": [
        3449
    ],
    "georgian": [
        3452,
        3453,
        3454,
        5850
    ],
    "gorji": [
        3452,
        3453,
        3454
    ],
    "grunzinski yazyk": [
        3452,
        3453,
        3454
    ],
    "grunzinski": [
        3452,
        3453,
        3454
    ],
    "gruzin": [
        3452,
        3453,
        3454
    ],
    "gazhuo": [
        3464,
        3997
    ],
    "gezhuo": [
        3464
    ],
    "galaagu": [
        3478
    ],
    "goniwoladi ejiwajegi": [
        3480
    ],
    "goniwoladi": [
        3480
    ],
    "gandanju": [
        3482
    ],
    "gandju": [
        3482
    ],
    "grass koiari": [
        3487
    ],
    "gabadi": [
        3498
    ],
    "guboy": [
        3515
    ],
    "gela": [
        5547,
        3517
    ],
    "gula (central african republic)": [
        3518
    ],
    "gula du mamoun": [
        3518
    ],
    "gadhang": [
        3532
    ],
    "gadjang": [
        3532
    ],
    "gathang": [
        3532
    ],
    "gyong": [
        3544
    ],
    "gong": [
        3544,
        5440,
        7924
    ],
    "gwong": [
        3544,
        8923,
        8924,
        8925,
        8926
    ],
    "girru": [
        3564
    ],
    "gakagba": [
        3578
    ],
    "gamale": [
        3627
    ],
    "gamale kham": [
        3627
    ],
    "gungari": [
        3629
    ],
    "gunggari": [
        3629
    ],
    "gambalamam": [
        3636
    ],
    "gumbaingari": [
        3636
    ],
    "gumbainggar": [
        3636
    ],
    "gumbainggir": [
        3636
    ],
    "gumbaynggir": [
        3636
    ],
    "gumbayunggir": [
        3636
    ],
    "gyirong": [
        3642
    ],
    "gikuyu": [
        3670
    ],
    "gekoyo": [
        3670
    ],
    "gĩgĩkũyũ": [
        3670
    ],
    "garab": [
        3671
    ],
    "gaigwu": [
        3683
    ],
    "gïrgïs": [
        3705
    ],
    "guguminjen": [
        3711
    ],
    "gazaqi": [
        3728,
        3730,
        3731,
        3732,
        3733
    ],
    "gon shan": [
        3743
    ],
    "gon": [
        3743
    ],
    "garko": [
        3751
    ],
    "gugubera": [
        3752
    ],
    "giiwo": [
        3755
    ],
    "guugu yimidhirr": [
        3761
    ],
    "guugu": [
        3761
    ],
    "gugu yimijir": [
        3761
    ],
    "gugu-yimidhirr": [
        3761
    ],
    "guguyimidjir": [
        3761
    ],
    "guugu yimithirr": [
        3761
    ],
    "greenlandic": [
        3763
    ],
    "greenlandic inuktitut": [
        3763
    ],
    "greenlandic kalaallisut": [
        3763
    ],
    "grønlandsk": [
        3763
    ],
    "gamilaraay": [
        3767
    ],
    "gamilaroi": [
        3767
    ],
    "galumpang": [
        3772
    ],
    "gimme": [
        3808
    ],
    "gimma": [
        3808
    ],
    "gwama": [
        3809
    ],
    "goryeomal": [
        3847,
        3848,
        3850
    ],
    "gbakpwa": [
        3885
    ],
    "gbe, kotafon": [
        3908
    ],
    "gawra": [
        3913
    ],
    "gabri-kimré": [
        3913
    ],
    "gizi": [
        3916,
        3972
    ],
    "gorachouqua": [
        3924
    ],
    "gigantes": [
        3931
    ],
    "gbaya (sudan)": [
        3942
    ],
    "gunantuna": [
        3957
    ],
    "goré": [
        3969
    ],
    "gisi": [
        3972
    ],
    "gissi": [
        3972
    ],
    "gugada": [
        3985
    ],
    "galgadungu": [
        3988
    ],
    "galgaduun": [
        3988
    ],
    "goji": [
        4021
    ],
    "guicurú": [
        4022
    ],
    "gikuria": [
        4023
    ],
    "guaporé": [
        4032
    ],
    "goltsan": [
        4035
    ],
    "gugadja": [
        4038
    ],
    "gugu yau": [
        4039
    ],
    "gablai": [
        4050
    ],
    "geba": [
        4061,
        4062
    ],
    "geba karen": [
        4061,
        4062
    ],
    "gawanga": [
        4082
    ],
    "glefe": [
        4087
    ],
    "gaungtou": [
        4110
    ],
    "guarategaja": [
        4114
    ],
    "guaratira": [
        4114
    ],
    "guaratégaya": [
        4114
    ],
    "gaeli": [
        4171
    ],
    "giudeo-espagnol": [
        4189,
        4190,
        4191
    ],
    "giudeo-espaneol": [
        4189,
        4190,
        4191
    ],
    "godogodo": [
        4203
    ],
    "gondhla": [
        4222,
        4223
    ],
    "gondla": [
        4222,
        4223
    ],
    "gu-ba": [
        4224
    ],
    "gurunsi": [
        4270
    ],
    "gelimi": [
        4285
    ],
    "gendja": [
        4312
    ],
    "gendza-bali": [
        4312
    ],
    "garas": [
        4316
    ],
    "golpa": [
        4349
    ],
    "golba": [
        4349
    ],
    "golbu": [
        4349
    ],
    "gorlba": [
        4349
    ],
    "gorlpa": [
        4349
    ],
    "galamai": [
        4366
    ],
    "galamaya": [
        4366
    ],
    "gaua": [
        7460,
        4367
    ],
    "gworam": [
        4374
    ],
    "gestu": [
        4390
    ],
    "gestų": [
        4390
    ],
    "gohar-herkeri": [
        4406,
        4407,
        4408
    ],
    "goola": [
        4406,
        4407,
        4408
    ],
    "gormati": [
        4406,
        4407,
        4408
    ],
    "gurmarti": [
        4406,
        4407,
        4408
    ],
    "glo skad": [
        4465,
        4466
    ],
    "glo": [
        4465,
        4466
    ],
    "gulumirrgin": [
        4478
    ],
    "giur": [
        4554
    ],
    "goa": [
        4582,
        4583,
        4584,
        8471
    ],
    "guariba": [
        4608
    ],
    "guariba-tapuyo": [
        4608
    ],
    "guamaca": [
        4614
    ],
    "guamaka": [
        4614
    ],
    "guaviare": [
        4616
    ],
    "gimbunda": [
        4635
    ],
    "geragau": [
        4637
    ],
    "gimbala": [
        4666
    ],
    "gura": [
        4735
    ],
    "gova": [
        4786
    ],
    "gudur": [
        4797
    ],
    "goudour": [
        4797
    ],
    "guichicovi mixe": [
        4810
    ],
    "guichicovi": [
        4810
    ],
    "gem mun": [
        4824
    ],
    "gem": [
        4824
    ],
    "great tunic yao": [
        4824
    ],
    "gulompaay": [
        4888
    ],
    "ghao-xong": [
        4918,
        5139
    ],
    "garingei": [
        4919
    ],
    "garpunei": [
        4919
    ],
    "gisun": [
        4935,
        4936,
        4937
    ],
    "gena": [
        4966
    ],
    "gergiko": [
        4983
    ],
    "guerguiko": [
        4983
    ],
    "gun-marung": [
        4991
    ],
    "gunmarung": [
        4991
    ],
    "guelengdeng": [
        4994
    ],
    "g’kelendeg": [
        4994
    ],
    "g’kelendeng": [
        4994
    ],
    "gorno-mariy": [
        5049
    ],
    "gawir": [
        5066
    ],
    "goliath": [
        5107
    ],
    "garama": [
        5179
    ],
    "goulfei": [
        5210
    ],
    "goulfey": [
        5210
    ],
    "gulfe": [
        5210
    ],
    "gulfei": [
        5210
    ],
    "geman dend": [
        5214
    ],
    "geman": [
        5214
    ],
    "geman deng": [
        5214
    ],
    "gbe, maxi": [
        5216
    ],
    "gisu": [
        5252
    ],
    "ghardaia": [
        5256,
        5257,
        5258
    ],
    "güisnay": [
        5263
    ],
    "ganja": [
        5285
    ],
    "gangela": [
        5310
    ],
    "ganguela": [
        5310
    ],
    "ganguella": [
        5310
    ],
    "gamawa": [
        5316
    ],
    "gbaka": [
        5320
    ],
    "gbala": [
        5320
    ],
    "gwaka": [
        5320
    ],
    "gente natural": [
        5345
    ],
    "gente": [
        5345
    ],
    "gorkhali": [
        5385,
        5386
    ],
    "gurkhali": [
        5385,
        5386
    ],
    "gwibwen": [
        5413
    ],
    "gnivo": [
        5417
    ],
    "gambo": [
        5418
    ],
    "gundangbon": [
        5430
    ],
    "geja": [
        5434
    ],
    "gvoko": [
        5437
    ],
    "gavoko": [
        5437
    ],
    "gevoko": [
        5437
    ],
    "ghboko": [
        5437
    ],
    "gәvoko": [
        5437
    ],
    "griang": [
        5438
    ],
    "guerrero aztec": [
        5439
    ],
    "guerrero nahuatl": [
        5439
    ],
    "goba": [
        5441
    ],
    "gombi": [
        5441
    ],
    "gangoulou": [
        5444
    ],
    "guaraní, ava": [
        5448
    ],
    "gbhu": [
        5480
    ],
    "gbhu d amar randfa": [
        5480
    ],
    "gilyak": [
        5487,
        5488
    ],
    "gudanji": [
        5497
    ],
    "gurdanji": [
        5497
    ],
    "gnamei": [
        5500
    ],
    "grangali": [
        5548
    ],
    "gelangali": [
        5548
    ],
    "gnamo": [
        5559
    ],
    "gindo": [
        5609
    ],
    "gongwang naga": [
        5643
    ],
    "gongwang": [
        5643
    ],
    "guernsey french": [
        5667
    ],
    "guernésiais": [
        5667
    ],
    "gnalla": [
        5670
    ],
    "gnalluma": [
        5671
    ],
    "gnalouma": [
        5671
    ],
    "gnormbur": [
        5679
    ],
    "gnumbu": [
        5679
    ],
    "gomen": [
        5725
    ],
    "gala": [
        5727
    ],
    "growoo": [
        5767
    ],
    "giriama": [
        5792
    ],
    "giryama": [
        5792
    ],
    "gyangiya": [
        5802
    ],
    "gascon, aranese": [
        5834
    ],
    "gascon": [
        5834
    ],
    "gascón": [
        5834
    ],
    "glio-oubi": [
        5999
    ],
    "glio": [
        5999
    ],
    "guaiapi": [
        6009
    ],
    "guayapi": [
        6009
    ],
    "gurmukhi": [
        6012,
        6013,
        6014,
        6015
    ],
    "gurumukhi": [
        6012,
        6013,
        6014,
        6015
    ],
    "ganai": [
        6017,
        6018,
        6019,
        7975
    ],
    "gwaɗi parǝkwa": [
        6049
    ],
    "gwaɗi": [
        6049
    ],
    "gwadi parekwa": [
        6049
    ],
    "gwadi": [
        6049
    ],
    "giai": [
        6062,
        6063
    ],
    "giang": [
        6062,
        6063,
        7163,
        9181
    ],
    "giay": [
        6062,
        6063
    ],
    "giáy": [
        6062,
        6063
    ],
    "ggia": [
        6062,
        6063
    ],
    "gorum": [
        6074
    ],
    "gorum sama": [
        6074
    ],
    "gorum-parenga": [
        6074
    ],
    "german, pennsylvania": [
        6082
    ],
    "gipende": [
        6100
    ],
    "giphende": [
        6100
    ],
    "gallinoméro": [
        6103
    ],
    "gāndhārī": [
        6112
    ],
    "gapinji": [
        6144
    ],
    "ghepinzi": [
        6144
    ],
    "guagua": [
        6145
    ],
    "golden palaung": [
        6191
    ],
    "guinea-bissau creole": [
        6264
    ],
    "guinea-bissau kriyol": [
        6264
    ],
    "guineense": [
        6264
    ],
    "gibiri": [
        6293
    ],
    "guarayu-ta": [
        6316
    ],
    "gestual": [
        6321
    ],
    "gennaken": [
        6358
    ],
    "günün yajich": [
        6358
    ],
    "günün": [
        6358
    ],
    "gününa küne": [
        6358
    ],
    "gününa": [
        6358
    ],
    "gününa yajich": [
        6358
    ],
    "gapapaiwa": [
        6376
    ],
    "genawa": [
        6385
    ],
    "gyema": [
        6385
    ],
    "gung": [
        6476
    ],
    "gîn": [
        6476
    ],
    "ganung-rawang": [
        6477,
        6478,
        6479,
        6480,
        6481,
        6482
    ],
    "gunga": [
        6503
    ],
    "gunganchi": [
        6503
    ],
    "gunganci": [
        6503
    ],
    "gungawa": [
        6503
    ],
    "gundurimba": [
        6538
    ],
    "gypsy jib": [
        6544
    ],
    "gypsy": [
        6544,
        6553,
        6554,
        6555,
        6560,
        6588,
        6590,
        6601
    ],
    "gitano": [
        6558
    ],
    "gironga": [
        6569
    ],
    "glai": [
        6586
    ],
    "gurbéti": [
        6588,
        6590
    ],
    "gungu": [
        6617
    ],
    "gara-wali": [
        6645
    ],
    "garuwali": [
        6645
    ],
    "goore": [
        6645
    ],
    "gamb-lai": [
        6691
    ],
    "gambai": [
        6691
    ],
    "gambaye": [
        6691
    ],
    "gamblai": [
        6691
    ],
    "gele’": [
        6693
    ],
    "gehimba": [
        6714
    ],
    "ghehimba": [
        6714
    ],
    "ghehimbaka": [
        6714
    ],
    "ganwari": [
        6726,
        6727
    ],
    "gauuari": [
        6726,
        6727
    ],
    "gawari": [
        6726,
        6727
    ],
    "goari": [
        6726,
        6727
    ],
    "gallurese": [
        6758
    ],
    "gallurese sardinian": [
        6758
    ],
    "gbajere": [
        6775
    ],
    "gulla": [
        6786
    ],
    "gao songhay": [
        6792
    ],
    "guinselugnen": [
        6800
    ],
    "gha-mu": [
        6801
    ],
    "ghab-mvb ghab-svd": [
        6801
    ],
    "ghab-mvb": [
        6801
    ],
    "ghab-svd": [
        6801
    ],
    "ghuab-hmongb ghuab-soud": [
        6801
    ],
    "ghuab-hmongb": [
        6801
    ],
    "ghuab-soud": [
        6801
    ],
    "ga’ay": [
        6810
    ],
    "gebärde": [
        6811
    ],
    "galim": [
        6815
    ],
    "gurage": [
        6825
    ],
    "great thai": [
        6845,
        6846,
        6847,
        6848
    ],
    "gyi": [
        6845,
        6846,
        6847,
        6848
    ],
    "geblet": [
        6857
    ],
    "garia": [
        6886
    ],
    "giella": [
        6908
    ],
    "gin": [
        8078,
        8079,
        8080,
        6922
    ],
    "gagana samoa": [
        6962
    ],
    "gagana": [
        6962
    ],
    "garengaze": [
        6995,
        6996
    ],
    "gangara": [
        7000,
        7001
    ],
    "genger": [
        7000,
        7001
    ],
    "gantëya coca": [
        7004
    ],
    "gantëya": [
        7004
    ],
    "ganteya": [
        7004
    ],
    "ganteya bain": [
        7004
    ],
    "gesogo": [
        7026
    ],
    "gitemi": [
        7048
    ],
    "gjuha shenjave e shqip": [
        7077
    ],
    "gjuha": [
        7077
    ],
    "gjuha shqiq e shenjave": [
        7077
    ],
    "gjuha e shenjave shqipe": [
        7077
    ],
    "gubat": [
        7121
    ],
    "gestuelle": [
        7146
    ],
    "giang ray": [
        7163
    ],
    "gie-trieng": [
        7163
    ],
    "gammon": [
        7164
    ],
    "goe": [
        7167
    ],
    "gumung": [
        7183,
        7184,
        7185,
        7186
    ],
    "gisir": [
        7237
    ],
    "gisira": [
        7237
    ],
    "gbe, saxwe": [
        7265
    ],
    "gemasakun": [
        7270
    ],
    "gyanan": [
        7275
    ],
    "godka": [
        7288
    ],
    "gŏdka": [
        7288
    ],
    "ghumghum": [
        7302
    ],
    "gaam": [
        7336
    ],
    "gaahmg": [
        7336
    ],
    "gəəməndən": [
        7336
    ],
    "gəəmg": [
        7336
    ],
    "gyot": [
        7390,
        7391,
        7599
    ],
    "gunua-kena": [
        7416
    ],
    "gununa-kena": [
        7416
    ],
    "gbe, tofin": [
        7437
    ],
    "gorkha": [
        7450
    ],
    "gugudayor": [
        7470
    ],
    "gajomang": [
        7575
    ],
    "gyoi": [
        7599
    ],
    "gabri-nord": [
        7619
    ],
    "gabri-north": [
        7619
    ],
    "gizrra": [
        7642
    ],
    "gizra": [
        7642
    ],
    "gitonga": [
        7644
    ],
    "guitonga": [
        7644
    ],
    "guarayú": [
        7667
    ],
    "guasurangue": [
        7667
    ],
    "galihalu": [
        7706
    ],
    "gambir": [
        7711
    ],
    "gwamba": [
        7727,
        7728
    ],
    "getsogo": [
        7748
    ],
    "ghetsogo": [
        7748
    ],
    "gaa": [
        7756
    ],
    "gage": [
        7843
    ],
    "gia tatana": [
        7858
    ],
    "getsaayi": [
        7864
    ],
    "gugu dhayban": [
        7869
    ],
    "gugu thaypan": [
        7869
    ],
    "gawigl": [
        7900,
        7901,
        7902
    ],
    "gawil": [
        7900,
        7901,
        7902
    ],
    "ganganda": [
        7959,
        7960
    ],
    "gooni": [
        7975
    ],
    "gunna": [
        7975
    ],
    "gunnai": [
        7975
    ],
    "giimbiyu": [
        7994,
        9085
    ],
    "gugu-uwanh": [
        8036
    ],
    "guvvalollu": [
        8045
    ],
    "gallinas": [
        8050,
        8051
    ],
    "gallines": [
        8050,
        8051
    ],
    "guarijío": [
        8058
    ],
    "gariera": [
        8090
    ],
    "gurama": [
        8100
    ],
    "givoungou": [
        8143
    ],
    "givungu": [
        8143
    ],
    "guayana": [
        8173
    ],
    "guarao": [
        8175
    ],
    "guarau": [
        8175
    ],
    "guarauno": [
        8175
    ],
    "guhjali": [
        8183,
        8184,
        8185
    ],
    "gbe, waci": [
        8195
    ],
    "gbe, weme": [
        8208
    ],
    "gamadoudou": [
        8218
    ],
    "gibara": [
        8218
    ],
    "gunbalang": [
        8257
    ],
    "gunbarlang": [
        8257
    ],
    "gungalang": [
        8257
    ],
    "gambian": [
        8310,
        8311
    ],
    "gambian wolof": [
        8310,
        8311
    ],
    "gobeyo": [
        8314
    ],
    "gongo": [
        8316
    ],
    "gudjal": [
        8325
    ],
    "gudjala": [
        8325
    ],
    "garrwa": [
        8328
    ],
    "gaarwa": [
        8328
    ],
    "garawa": [
        8328
    ],
    "garrawa": [
        8328
    ],
    "grawa": [
        8328
    ],
    "gugu warra": [
        8338
    ],
    "guguwarra": [
        8338
    ],
    "gondi, adilabad": [
        8343,
        8344,
        8345,
        8346
    ],
    "gunjala gondi": [
        8343,
        8344,
        8345,
        8346
    ],
    "gunjala": [
        8343,
        8344,
        8345,
        8346
    ],
    "ghou nyu": [
        8369,
        8370,
        8371
    ],
    "ghou": [
        8369,
        8370,
        8371
    ],
    "goetian": [
        8369,
        8370,
        8371
    ],
    "gniu": [
        8369,
        8370,
        8371
    ],
    "gungung-willam": [
        8384
    ],
    "gnoolongbara": [
        8426
    ],
    "gaulish": [
        8430,
        8650
    ],
    "gra": [
        8451
    ],
    "giǀkxigwi": [
        8452
    ],
    "galatian": [
        8461
    ],
    "gbin": [
        8462
    ],
    "gudang": [
        8463
    ],
    "gootung": [
        8463
    ],
    "gabrielino-fernandeño": [
        8464
    ],
    "garingbal": [
        8466
    ],
    "galindan": [
        8467
    ],
    "guwinmal": [
        8468
    ],
    "garza": [
        8469
    ],
    "guwa": [
        8471
    ],
    "goamalku": [
        8471
    ],
    "goamulgo": [
        8471
    ],
    "gri": [
        8483
    ],
    "grikwa": [
        8483
    ],
    "griqua": [
        8483
    ],
    "gry": [
        8483
    ],
    "gan-dowal": [
        8490
    ],
    "gando minjang": [
        8490
    ],
    "gendo": [
        8490
    ],
    "gundungerre": [
        8491
    ],
    "gurtü": [
        8515,
        8516
    ],
    "gamor": [
        8550
    ],
    "gamu": [
        8550
    ],
    "garego": [
        8560
    ],
    "gur-mal": [
        8560
    ],
    "guramal": [
        8560
    ],
    "gokwom": [
        8580
    ],
    "gundungurra": [
        8617
    ],
    "gandangara": [
        8617
    ],
    "gundanora": [
        8617
    ],
    "gundungari": [
        8617
    ],
    "gundungorra": [
        8617
    ],
    "gurra-gunga": [
        8617
    ],
    "guaika": [
        8642
    ],
    "guyanagal": [
        8665
    ],
    "guyangal-yuin": [
        8665
    ],
    "gurungada": [
        8676
    ],
    "garandi": [
        8683
    ],
    "glanda-khwe": [
        8684
    ],
    "gbe, xwela": [
        8693
    ],
    "gbe, western xwla": [
        8697
    ],
    "guli-ballaiuk": [
        8700
    ],
    "gorrmjanyuk": [
        8701
    ],
    "gourrmjanyuk": [
        8701
    ],
    "gunbowerooranditchgoole": [
        8713
    ],
    "gunbowers": [
        8713
    ],
    "gounou": [
        8738
    ],
    "gunu": [
        8738
    ],
    "gwune": [
        8744
    ],
    "gohum": [
        8754
    ],
    "gaoshanzu": [
        8761
    ],
    "german travellers": [
        8770
    ],
    "gel": [
        8783
    ],
    "gepo": [
        8785
    ],
    "gepu": [
        8785
    ],
    "gupu": [
        8785
    ],
    "guzu": [
        8785
    ],
    "guangnan buyang": [
        8790
    ],
    "guangnan": [
        8790
    ],
    "gerrah": [
        8799
    ],
    "gijow": [
        8799
    ],
    "gillah": [
        8799
    ],
    "guwamal": [
        8799
    ],
    "gasu": [
        8824
    ],
    "gan yi": [
        8835,
        8858
    ],
    "gbendere": [
        8861
    ],
    "giy": [
        8882
    ],
    "geral": [
        8896
    ],
    "guangxi buyang": [
        8898
    ],
    "gni ni": [
        8908
    ],
    "gni": [
        8908
    ],
    "guangdong": [
        8923,
        8924,
        8925,
        8926
    ],
    "guangfu": [
        8923,
        8924,
        8925,
        8926
    ],
    "gwong dung": [
        8923,
        8924,
        8925,
        8926
    ],
    "gbinna": [
        8934
    ],
    "guelavía": [
        8970
    ],
    "guibei": [
        9013
    ],
    "guibei zhuang": [
        9013
    ],
    "guibian": [
        9016
    ],
    "guibian zhuang": [
        9016
    ],
    "gadu": [
        9061
    ],
    "ganaan": [
        9065
    ],
    "ganan": [
        9065
    ],
    "ganon": [
        9065
    ],
    "genan": [
        9065
    ],
    "gaurna": [
        9071
    ],
    "gair": [
        9087
    ],
    "guevea": [
        9126
    ],
    "guevea de humboldt zapotec": [
        9126
    ],
    "güilá": [
        9169
    ],
    "güilá zapotec": [
        9169
    ],
    "gamoze": [
        9175
    ],
    "gamuso": [
        9175
    ],
    "gen yang": [
        9181
    ]
};
